import { computed } from 'vue';
import { useStore } from 'vuex';

export function useStoreData() {
  const store = useStore();
  const getDurationTime = computed(
    () => store.getters['globalState/settings/getDurationTime'],
  );
  const getTimeZoneOff = computed(
    () => store.getters['globalState/settings/getTimeZoneOff'],
  );

  const intervalTime = computed(
    () => store.getters['globalState/settings/intervalTime'],
  );

  const currentService = computed(
    () => store.getters['apmState/apmCommonState/getCurrentApmService'],
  );

  const currentSideNav = computed(
    () => store.getters['globalState/app/sideNav'],
  );

  const isForecastModalEnable = computed(
    () => store.getters['globalState/app/getIsForecastModalEnable'],
  );

  const isForecastEnable = computed(
    () => store.getters['globalState/app/getIsForecastEnable'],
  );

  const setIsForecastModalEnable = (data) =>
    store.commit('globalState/app/setIsForecastModalEnable', data);

  const durationShow = computed(
    () => store.getters['globalState/settings/durationShow'],
  );

  const setDuration = (data) =>
    store.dispatch('globalState/settings/setDuration', data);

  const setCurrTimeLabel = (data) =>
    store.dispatch('globalState/settings/setCurrTimeLabel', data);

  const getCurrTimeLabel = computed(
    () => store.getters['globalState/settings/getCurrTimeLabel'],
  );

  const utc = computed(() => store.getters['globalState/settings/getUTC']);

  return {
    getDurationTime,
    getTimeZoneOff,
    intervalTime,
    currentService,
    currentSideNav,
    setIsForecastModalEnable,
    isForecastModalEnable,
    durationShow,
    setDuration,
    setCurrTimeLabel,
    getCurrTimeLabel,
    utc,
    isForecastEnable,
  };
}
